/* NeeT landinzi: ponude (dodaj u korpu), "izaberi 3" i lepljiva traka. Bez zavisnosti. */
(function () {
  'use strict';

  var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

  function dodaj(items, btn, greska, posle) {
    if (!items.length) return;
    var natpis = btn.querySelector('[data-lp-kupi-tekst]') || btn;
    var stari = natpis.textContent;
    function vrati() {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      natpis.textContent = stari;
    }
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    natpis.textContent = 'Učitava se…';
    // povratak sa plaćanja dugmetom Nazad vraća zamrznutu stranu: dugme mora opet da radi
    window.addEventListener('pageshow', function (e) { if (e.persisted) vrati(); }, { once: true });
    if (greska) greska.textContent = '';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Greška');
          return d;
        });
      })
      .then(function () {
        window.location.href = posle || '/checkout';
      })
      .catch(function (e) {
        vrati();
        if (greska) greska.textContent = 'Nije uspelo dodavanje u korpu: ' + e.message + '. Pokušajte ponovo.';
      });
  }

  /* Ponude sa izborom paketa */
  function ponude(root) {
    var btn = root.querySelector('[data-lp-kupi]');
    var txt = root.querySelector('[data-lp-kupi-tekst]');
    var greska = root.querySelector('[data-lp-greska]');
    var radios = root.querySelectorAll('input[type="radio"]');

    function osvezi() {
      var on = root.querySelector('input[type="radio"]:checked');
      radios.forEach(function (r) {
        r.closest('.lp-ponuda').classList.toggle('is-on', r.checked);
      });
      if (on && txt && on.dataset.dugme) txt.textContent = on.dataset.dugme;
      document.dispatchEvent(new CustomEvent('lp:ponuda', { detail: { input: on } }));
    }
    radios.forEach(function (r) { r.addEventListener('change', osvezi); });
    osvezi();

    root.addEventListener('submit', function (e) {
      e.preventDefault();
      var on = root.querySelector('input[type="radio"]:checked');
      if (!on) return;
      if (on.dataset.link) {
        var cilj = on.dataset.link.charAt(0) === '#' && document.querySelector(on.dataset.link);
        if (cilj && cilj.tagName === 'DIALOG') {
          otvori(cilj);
        } else if (cilj) {
          cilj.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', on.dataset.link);
        } else {
          window.location.href = on.dataset.link;
        }
        return;
      }
      var items = [];
      try { items = JSON.parse(on.dataset.items || '[]'); } catch (err) { items = []; }
      if (!items.length) {
        if (greska) greska.textContent = 'Ovaj paket još nije povezan sa proizvodom.';
        return;
      }
      dodaj(items, btn, greska, root.dataset.posle);
    });
  }

  /* Izaberi N proizvoda iz kolekcije */
  function biraj(root) {
    var nivoi = root.querySelectorAll('input[name^="lp-nivo"]');
    var proizvodi = root.querySelectorAll('[data-lp-p]');
    var btn = root.querySelector('[data-lp-kupi]');
    var txt = root.querySelector('[data-lp-kupi-tekst]');
    var brojac = root.querySelector('[data-lp-izabrano]');
    var traka = root.querySelector('[data-lp-traka]');
    var greska = root.querySelector('[data-lp-greska]');
    var cilj = 3;

    function ukupno() {
      var n = 0;
      proizvodi.forEach(function (p) { n += parseInt(p.dataset.kol || '0', 10); });
      return n;
    }

    function osvezi() {
      var on = root.querySelector('input[name^="lp-nivo"]:checked');
      if (on) cilj = parseInt(on.dataset.broj, 10) || 1;
      nivoi.forEach(function (r) { r.closest('.lp-ponuda').classList.toggle('is-on', r.checked); });
      document.dispatchEvent(new CustomEvent('lp:ponuda', { detail: { input: on } }));
      var n = ukupno();
      /* ako je smanjen nivo, skini visak od poslednjeg izabranog */
      for (var i = proizvodi.length - 1; i >= 0 && n > cilj; i--) {
        var k = parseInt(proizvodi[i].dataset.kol || '0', 10);
        var skini = Math.min(k, n - cilj);
        proizvodi[i].dataset.kol = k - skini;
        n -= skini;
      }
      proizvodi.forEach(function (p) {
        var k = parseInt(p.dataset.kol || '0', 10);
        p.querySelector('output').textContent = k;
        p.classList.toggle('is-on', k > 0);
        p.querySelector('[data-lp-minus]').disabled = k === 0;
        p.querySelector('[data-lp-plus]').disabled = n >= cilj;
      });
      if (brojac) brojac.textContent = n + ' / ' + cilj;
      if (traka) traka.style.width = Math.min(100, (n / cilj) * 100) + '%';
      var gotovo = n === cilj;
      btn.disabled = !gotovo;
      if (txt) {
        if (gotovo) txt.textContent = (on && on.dataset.dugme) || txt.dataset.gotovo || 'Poruči paket';
        else txt.textContent = (txt.dataset.fali || 'Izaberite još [n]').replace('[n]', cilj - n);
      }
    }

    nivoi.forEach(function (r) { r.addEventListener('change', osvezi); });
    proizvodi.forEach(function (p) {
      p.querySelector('[data-lp-plus]').addEventListener('click', function () {
        if (ukupno() >= cilj) return;
        p.dataset.kol = parseInt(p.dataset.kol || '0', 10) + 1;
        osvezi();
      });
      p.querySelector('[data-lp-minus]').addEventListener('click', function () {
        var k = parseInt(p.dataset.kol || '0', 10);
        if (k > 0) p.dataset.kol = k - 1;
        osvezi();
      });
    });
    osvezi();

    root.addEventListener('submit', function (e) {
      e.preventDefault();
      if (ukupno() !== cilj) return;
      var items = [];
      proizvodi.forEach(function (p) {
        var k = parseInt(p.dataset.kol || '0', 10);
        if (k > 0) items.push({ id: parseInt(p.dataset.id, 10), quantity: k });
      });
      dodaj(items, btn, greska, root.dataset.posle);
    });
  }

  /* Lepljiva traka: pojavi se kad prvo dugme za kupovinu izadje iz ekrana, sakrij kod drugih ponuda */
  function lepljiva(bar) {
    if (!('IntersectionObserver' in window)) return;
    var ponudeEl = Array.prototype.filter.call(
      document.querySelectorAll('[data-lp-ponude], [data-lp-biraj]'),
      function (el) { return !el.closest('dialog'); }
    );
    var modal = document.querySelector('dialog[data-lp-modal]');
    if (!ponudeEl.length) {
      var hero = document.querySelector('.lp-hero');
      if (!hero) return;
      ponudeEl = [hero];
    }
    var vidljive = new Set();
    var prvaProsla = false;
    var prva = ponudeEl[0];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) vidljive.add(en.target);
        else vidljive.delete(en.target);
        if (en.target === prva) prvaProsla = !en.isIntersecting && en.boundingClientRect.top < 0;
      });
      var odmah = bar.hasAttribute('data-mob-odmah') && window.matchMedia('(max-width: 749px)').matches;
      var prikazi = vidljive.size === 0 && (odmah || prvaProsla || prva.getBoundingClientRect().top < 0);
      bar.classList.toggle('is-on', prikazi);
      bar.setAttribute('aria-hidden', prikazi ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = prikazi ? 0 : -1; });
    });
    ponudeEl.forEach(function (el) { io.observe(el); });

    var link = bar.querySelector('[data-lp-skok]');
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        /* izabran paket sa prozorom (ili nema izbora na stranici) -> otvori prozor */
        var izabran = prva.querySelector && prva.querySelector('input[type="radio"]:checked');
        var uProzor = modal && (!prva.matches('[data-lp-ponude], [data-lp-biraj]') ||
          (izabran && izabran.dataset.link && document.querySelector(izabran.dataset.link) === modal));
        if (uProzor) { otvori(modal); return; }
        prva.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var fokus = prva.querySelector('input:checked, input, button');
        if (fokus) setTimeout(function () { fokus.focus({ preventScroll: true }); }, 500);
      });
    }

    /* tekst i cena prate izabranu ponudu */
    var naziv = bar.querySelector('[data-lp-lep-naziv]');
    var cena = bar.querySelector('[data-lp-lep-cena]');
    document.addEventListener('lp:ponuda', function (e) {
      var inp = e.detail && e.detail.input;
      if (!inp || inp.closest('[data-lp-ponude], [data-lp-biraj]') !== prva) return;
      if (naziv && inp.dataset.naziv) naziv.textContent = inp.dataset.naziv;
      if (cena && inp.dataset.cena) cena.textContent = inp.dataset.cena;
    });
  }

  /* Prozor (dialog) za slaganje paketa */
  function otvori(d) {
    if (!d || d.open) return;
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
    document.documentElement.classList.add('lp-modal-otvoren');
  }

  function zatvori(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close();
    else d.removeAttribute('open');
  }

  function limenke(n, akuzativ) {
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return n + (akuzativ ? ' limenku' : ' limenka');
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return n + ' limenke';
    return n + ' limenki';
  }

  function paket(d) {
    var forma = d.querySelector('[data-lp-paket]');
    var nivoi = Array.prototype.map.call(d.querySelectorAll('[data-lp-nivo]'), function (el) {
      return { broj: parseInt(el.dataset.broj, 10), naziv: el.dataset.naziv, cena: el.dataset.cena,
        ispod: el.dataset.ispod, nagrada: el.dataset.nagrada, dugme: el.dataset.dugme, usteda: el.dataset.usteda, mamac: el.dataset.mamac };
    }).sort(function (a, b) { return a.broj - b.broj; });
    var najvise = parseInt(d.dataset.najvise || '0', 10) || Infinity;
    var vrhNivoa = nivoi.length ? nivoi[nivoi.length - 1].broj : 3;
    var max = najvise;
    function broj(t) { return parseInt(String(t || '').replace(/[^0-9]/g, ''), 10) || 0; }
    function rsd(x) { return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' RSD'; }
    var jedna = nivoi.length && nivoi[0].broj === 1 ? broj(nivoi[0].cena) : 0;
    /* najpovoljnija kombinacija paketa za n limenki */
    function kombinacija(n) {
      var best = [{ c: 0, sast: [] }];
      for (var k = 1; k <= n; k++) {
        best[k] = null;
        nivoi.forEach(function (nv) {
          var c = broj(nv.cena);
          if (nv.broj <= k && c && best[k - nv.broj]) {
            var uk = best[k - nv.broj].c + c;
            if (!best[k] || uk < best[k].c) best[k] = { c: uk, sast: best[k - nv.broj].sast.concat([nv]) };
          }
        });
      }
      return best[n];
    }
    function opisKomb(sast) {
      var brojac = {}, red = [];
      sast.forEach(function (nv) { if (!brojac[nv.naziv]) { brojac[nv.naziv] = 0; red.push(nv); } brojac[nv.naziv]++; });
      red.sort(function (a, b) { return b.broj - a.broj; });
      return red.map(function (nv) { return (brojac[nv.naziv] > 1 ? brojac[nv.naziv] + ' × ' : '') + nv.naziv; }).join(' + ');
    }
    var redovi = d.querySelectorAll('[data-lp-p]');
    var btn = d.querySelector('[data-lp-kupi]');
    var txt = d.querySelector('[data-lp-kupi-tekst]');
    var poruka = d.querySelector('[data-lp-poruka]');
    var traka = d.querySelector('[data-lp-traka]');
    var pragovi = d.querySelectorAll('[data-lp-prag]');
    var ukupnoEl = d.querySelector('[data-lp-ukupno]');
    var nazivEl = d.querySelector('[data-lp-paket-naziv]');
    var cenaEl = d.querySelector('[data-lp-cena]');
    var ispodEl = d.querySelector('[data-lp-ispod]');
    var greska = d.querySelector('[data-lp-greska]');

    function ukupno() {
      var n = 0;
      redovi.forEach(function (r) { n += parseInt(r.dataset.kol || '0', 10); });
      return n;
    }

    function osvezi() {
      var n = ukupno();
      var tacan = null, sledeci = null;
      nivoi.forEach(function (nv) {
        if (nv.broj === n) tacan = nv;
        if (!sledeci && nv.broj > n) sledeci = nv;
      });
      var komb = n > 0 ? kombinacija(n) : null;
      var cenaUk = komb ? komb.c : 0;
      var usteda = jedna && komb ? jedna * n - cenaUk : 0;
      var naziv = tacan ? tacan.naziv : (komb ? opisKomb(komb.sast) : '');
      redovi.forEach(function (r) {
        var k = parseInt(r.dataset.kol || '0', 10);
        r.classList.toggle('is-on', k > 0);
        r.querySelector('output').textContent = k;
        r.querySelector('[data-lp-plus]').disabled = n >= max;
        r.querySelector('[data-lp-dodaj]').disabled = n >= max;
      });
      if (traka) traka.style.width = Math.min(100, (n / vrhNivoa) * 100) + '%';
      pragovi.forEach(function (p) { p.classList.toggle('is-on', n >= parseInt(p.dataset.lpPrag, 10)); });
      function esc(t) { var x = document.createElement('span'); x.textContent = t; return x.innerHTML; }
      function dalje(nv) {
        var t = 'Dodaj još <b>' + limenke(nv.broj - n, true) + '</b> za <b>' + esc(nv.naziv) + '</b>';
        return t + (nv.mamac ? (/^[,.]/.test(nv.mamac) ? '' : ' ') + esc(nv.mamac) : '') + '.';
      }
      var ustedaTxt = tacan && tacan.usteda ? tacan.usteda : (usteda > 0 ? rsd(usteda) : '');
      function izabrano() {
        return 'Izabrano: <b>' + esc(naziv) + '</b>' + (ustedaTxt ? ' (ušteda ' + esc(ustedaTxt) + ')' : '');
      }
      var tekst;
      if (n === 0) tekst = 'Izaberi limenke za paket.';
      else if (sledeci) tekst = izabrano() + '. ' + dalje(sledeci);
      else if (n >= max) tekst = izabrano() + '. Najviše ' + limenke(max) + ' u jednoj porudžbini.';
      else tekst = izabrano() + (tacan && tacan.nagrada ? ' · ' + esc(tacan.nagrada) : '') + '.';
      if (poruka) poruka.innerHTML = tekst;
      if (ukupnoEl) ukupnoEl.textContent = limenke(n);
      if (nazivEl) nazivEl.textContent = naziv && naziv !== limenke(n) ? '· ' + naziv : '';
      if (cenaEl) cenaEl.textContent = n ? (tacan ? tacan.cena : rsd(cenaUk)) : '';
      if (ispodEl) ispodEl.textContent = tacan && tacan.ispod ? tacan.ispod : (n > 1 && cenaUk ? rsd(Math.round(cenaUk / n)).replace(' RSD', '') + ' po limenci' : '');
      var ustedaEl = d.querySelector('[data-lp-usteda]');
      if (ustedaEl) ustedaEl.textContent = ustedaTxt ? 'ušteda ' + ustedaTxt : '';
      btn.disabled = n === 0;
      if (txt) txt.textContent = n === 0 ? 'Izaberi limenke' : (tacan && tacan.dugme ? tacan.dugme : 'Poruči ' + limenke(n, true));
    }

    /* otvaranje sa karticom: ta limenka se odmah dodaje (ako ima mesta i jos nije u paketu) */
    d._lpDodaj = function (id) {
      var r = d.querySelector('[data-lp-p][data-id="' + id + '"]');
      if (!r) return;
      if (parseInt(r.dataset.kol || '0', 10) === 0 && ukupno() < max) {
        r.dataset.kol = 1;
        osvezi();
      }
      setTimeout(function () { r.scrollIntoView({ block: 'nearest' }); }, 50);
    };

    /* gotova kombinacija: prozor se popuni tacno tim limenkama (lista id-jeva, ponavljanje = vise komada) */
    d._lpPostavi = function (lista) {
      var broj = {};
      String(lista || '').split(',').forEach(function (id) { id = id.trim(); if (id) broj[id] = (broj[id] || 0) + 1; });
      redovi.forEach(function (r) { r.dataset.kol = broj[r.dataset.id] || 0; });
      osvezi();
      var prvi = d.querySelector('[data-lp-p].is-on');
      if (prvi) setTimeout(function () { prvi.scrollIntoView({ block: 'nearest' }); }, 50);
    };

    redovi.forEach(function (r) {
      function dodaj1() {
        if (ukupno() >= max) return;
        r.dataset.kol = parseInt(r.dataset.kol || '0', 10) + 1;
        osvezi();
      }
      r.querySelector('[data-lp-dodaj]').addEventListener('click', function () {
        dodaj1();
        var plus = r.querySelector('[data-lp-plus]');
        if (plus) plus.focus();
      });
      r.querySelector('[data-lp-plus]').addEventListener('click', dodaj1);
      r.querySelector('[data-lp-minus]').addEventListener('click', function () {
        var k = parseInt(r.dataset.kol || '0', 10);
        if (k > 0) r.dataset.kol = k - 1;
        osvezi();
        if (k - 1 === 0) r.querySelector('[data-lp-dodaj]').focus();
      });
    });
    osvezi();

    forma.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var items = [];
      redovi.forEach(function (r) {
        var k = parseInt(r.dataset.kol || '0', 10);
        if (k > 0) items.push({ id: parseInt(r.dataset.id, 10), quantity: k });
      });
      dodaj(items, btn, greska, forma.dataset.posle);
    });

    /* zatvaranje: dugme X, klik van prozora; Esc radi sam (dialog) */
    d.querySelectorAll('[data-lp-zatvori]').forEach(function (x) {
      x.addEventListener('click', function () { zatvori(d); });
    });
    d.addEventListener('click', function (e) { if (e.target === d) zatvori(d); });
    d.addEventListener('close', function () { document.documentElement.classList.remove('lp-modal-otvoren'); });

    /* otvaranje: svaki link na #sidro ili [data-lp-otvori] */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#' + d.id + '"], [data-lp-otvori="' + d.id + '"]');
      if (!a || a.closest('[data-lp-lepljiva]')) return;
      e.preventDefault();
      otvori(d);
      if (a.dataset.lpProizvod) d._lpDodaj(a.dataset.lpProizvod);
      if (a.dataset.lpProizvodi !== undefined) d._lpPostavi(a.dataset.lpProizvodi);
    });
    if (window.location.hash === '#' + d.id) otvori(d);
  }

  /* Galerija u heru: klik na sličicu menja glavnu sliku */
  function galerija(root) {
    var glavna = root.querySelector('.lp-galerija__glavna img');
    var dugmad = root.querySelectorAll('.lp-galerija__dugme');
    if (!glavna) return;
    dugmad.forEach(function (d) {
      d.addEventListener('click', function () {
        glavna.removeAttribute('srcset');
        glavna.src = d.dataset.src;
        glavna.srcset = d.dataset.srcset;
        if (d.dataset.alt) glavna.alt = d.dataset.alt;
        dugmad.forEach(function (x) { x.classList.remove('is-on'); x.removeAttribute('aria-current'); });
        d.classList.add('is-on');
        d.setAttribute('aria-current', 'true');
      });
    });
  }

  /* Karusel (prevlacenje na telefonu): tacke prate trenutni slajd */
  /* odlozene slike (data-lp-srcset): pustaju se posle ucitavanja stranice ili na prvo prevlacenje */
  function pustiOdlozene(root) {
    root.querySelectorAll('img[data-lp-srcset]').forEach(function (img) {
      img.srcset = img.dataset.lpSrcset;
      img.src = img.dataset.lpSrc;
      img.removeAttribute('data-lp-srcset');
    });
  }

  function karusel(root) {
    var traka = root.querySelector('.lp-karusel__traka');
    if (root.querySelector('img[data-lp-srcset]')) {
      var pusti = function () { pustiOdlozene(root); };
      if (traka) traka.addEventListener('scroll', pusti, { once: true, passive: true });
      if (document.readyState === 'complete') setTimeout(pusti, 1500);
      else window.addEventListener('load', function () { setTimeout(pusti, 1500); });
    }
    var tacke = root.querySelectorAll('.lp-karusel__tacke i');
    if (!traka || !tacke.length) return;
    var slajdovi = traka.children;
    var cekaj = null;
    traka.addEventListener('scroll', function () {
      if (cekaj) return;
      cekaj = requestAnimationFrame(function () {
        cekaj = null;
        var levo = traka.getBoundingClientRect().left;
        var najblizi = 0, min = Infinity;
        for (var i = 0; i < slajdovi.length; i++) {
          var d = Math.abs(slajdovi[i].getBoundingClientRect().left - levo);
          if (d < min) { min = d; najblizi = i; }
        }
        tacke.forEach(function (t, i) { t.classList.toggle('is-on', i === najblizi); });
      });
    }, { passive: true });
  }

  /* Video: ucitava se i pusta tek kad je na ekranu, pauzira kad izadje */
  function videi() {
    var sve = document.querySelectorAll('video[data-lp-video]');
    if (!sve.length) return;
    var smanji = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window)) return;
    /* pocetna slika (poster) tek kad se video priblizi ekranu */
    var blizu = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var v = en.target;
        if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster;
        blizu.unobserve(v);
      });
    }, { rootMargin: '300px 300px' });
    sve.forEach(function (v) { blizu.observe(v); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        var vidljivo = en.isIntersecting && (v.loop || en.intersectionRatio >= 0.85);
        if (en.isIntersecting && !v.src && v.dataset.src) { v.src = v.dataset.src; v.preload = 'auto'; }
        if (vidljivo) {
          if (!smanji && !(v.ended && !v.loop)) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else if (!en.isIntersecting) {
          if (!v.paused) v.pause();
          /* video koji se pusta jednom krece ispocetka kad se kupac vrati do njega */
          if (!v.loop && v.currentTime > 0) v.currentTime = 0;
        }
      });
    }, { threshold: [0, 0.4, 0.85] });
    sve.forEach(function (v) { io.observe(v); });
  }

  /* Niz kadrova vezan za skrolovanje (kao Scandi): kadrovi se ucitavaju kad se sekcija priblizi,
     prvo svaki osmi pa ostali; izmedju susednih kadrova se pretapa, pa animacija ne secka */
  function sekvenca(root) {
    var platno = root.querySelector('canvas');
    var broj = parseInt(root.dataset.broj, 10);
    if (!platno || !broj) return;
    var ctx = platno.getContext('2d');
    var mob = root.dataset.urlMob && window.matchMedia('(max-width: 749px)').matches;
    var osnova = mob ? root.dataset.urlMob : root.dataset.url;
    var slike = new Array(broj), ucitano = 0, spremno = false, cilj = 0, trenutno = 0, nacrtano = -1, raf = null;
    var okvir = root.closest('.lp-sastojci-seq') || root;
    var sekcija = root.dataset.rezim === 'lepi' ? root.closest('[data-lp-pogled]') : null;
    var potpis = sekcija && sekcija.querySelector('[data-lp-pogled-potpis]');
    var smanji = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function url(i) { return osnova + String(i + 1).padStart(3, '0') + '.webp?' + root.dataset.v; }
    function velicina() {
      var r = platno.getBoundingClientRect();
      var px = Math.round(r.width * Math.min(window.devicePixelRatio || 1, 2));
      px = Math.max(320, Math.min(px, mob ? 720 : 1080));
      if (platno.width !== px) { platno.width = px; platno.height = px; nacrtano = -1; }
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
    }
    function gotova(img) { return img && img.complete && img.naturalWidth > 0; }
    function najblizi(i, smer) {
      for (var k = i; k >= 0 && k < broj; k += smer) { if (gotova(slike[k])) return k; }
      return -1;
    }
    function crtaj(poz) {
      var i = Math.floor(poz), f = poz - i;
      var a = najblizi(i, -1);
      if (a < 0) a = najblizi(i, 1);
      if (a < 0) return;
      var b = najblizi(Math.min(broj - 1, i + 1), 1);
      var kljuc = a + ':' + b + ':' + Math.round(f * 20);
      if (kljuc === nacrtano) return;
      var W = platno.width;
      ctx.globalAlpha = 1;
      ctx.drawImage(slike[a], 0, 0, W, W);
      if (b > a && f > 0.02) {
        ctx.globalAlpha = Math.min(1, (poz - a) / (b - a));
        ctx.drawImage(slike[b], 0, 0, W, W);
        ctx.globalAlpha = 1;
      }
      nacrtano = kljuc;
      if (sekcija) {
        try {
          var t = [[3, 3], [W - 4, 3], [3, W - 4], [W - 4, W - 4]], rr = 0, gg = 0, bb = 0;
          t.forEach(function (q) { var d = ctx.getImageData(q[0], q[1], 1, 1).data; rr += d[0]; gg += d[1]; bb += d[2]; });
          sekcija.style.setProperty('--lp-pogled-uzivo', 'rgb(' + Math.round(rr / 4) + ',' + Math.round(gg / 4) + ',' + Math.round(bb / 4) + ')');
        } catch (e) {}
      }
    }
    function napredak() {
      if (sekcija) {
        var rs = sekcija.getBoundingClientRect();
        var pp = -rs.top / Math.max(1, rs.height - window.innerHeight);
        pp = Math.max(0, Math.min(1, pp));
        if (potpis) potpis.classList.toggle('is-on', pp > 0.85);
        return pp;
      }
      var r = okvir.getBoundingClientRect(), vh = window.innerHeight;
      var p = (vh * 0.75 - r.top) / Math.max(1, r.height - vh * 0.25);
      return Math.max(0, Math.min(1, p));
    }
    function petlja() {
      trenutno += (cilj - trenutno) * 0.18;
      if (Math.abs(cilj - trenutno) * (broj - 1) < 0.03) trenutno = cilj;
      crtaj(trenutno * (broj - 1));
      raf = trenutno === cilj ? null : requestAnimationFrame(petlja);
    }
    /* kad skrol stane, prikaz se smesti na najblizi ceo kadar (bez dva preklopljena kadra) */
    var stani = null;
    function naSkrol() {
      cilj = napredak();
      if (!raf) raf = requestAnimationFrame(petlja);
      clearTimeout(stani);
      stani = setTimeout(function () {
        cilj = Math.round(napredak() * (broj - 1)) / (broj - 1);
        if (!raf) raf = requestAnimationFrame(petlja);
      }, 120);
    }
    function ucitaj() {
      var red = [], vidjen = {};
      [8, 4, 2, 1].forEach(function (korak) {
        for (var i = 0; i < broj; i += korak) { if (!vidjen[i]) { vidjen[i] = 1; red.push(i); } }
      });
      if (!vidjen[broj - 1]) red.splice(1, 0, broj - 1);
      var aktivno = 0, poz = 0;
      function sledeci() {
        while (aktivno < 6 && poz < red.length) {
          (function (i) {
            var img = new Image();
            img.decoding = 'async';
            img.onload = img.onerror = function () {
              aktivno--; ucitano++;
              if (!spremno && gotova(slike[0]) && ucitano >= Math.min(12, broj)) {
                spremno = true;
                root.classList.add('is-spremno');
                velicina();
                window.addEventListener('scroll', naSkrol, { passive: true });
                window.addEventListener('resize', function () { velicina(); naSkrol(); }, { passive: true });
              }
              if (spremno) { nacrtano = -1; naSkrol(); }
              sledeci();
            };
            img.src = url(i);
            slike[i] = img;
            aktivno++;
          })(red[poz++]);
        }
      }
      sledeci();
    }
    if (smanji || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { io.disconnect(); ucitaj(); }
    }, { rootMargin: '1200px 0px' });
    io.observe(root);
  }

  /* Paralaks pozadina: slika se pomera sporije od stranice */
  function paralaks() {
    var sve = document.querySelectorAll('[data-lp-paralaks]');
    if (!sve.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var raf = null;
    function pomeri() {
      raf = null;
      var vh = window.innerHeight;
      sve.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var pomak = (r.top + r.height / 2 - vh / 2) * -0.3;
        el.firstElementChild && (el.querySelector('img').style.transform = 'translate3d(0,' + pomak.toFixed(1) + 'px,0)');
      });
    }
    function zakazi() { if (!raf) raf = requestAnimationFrame(pomeri); }
    window.addEventListener('scroll', zakazi, { passive: true });
    window.addEventListener('resize', zakazi, { passive: true });
    pomeri();
  }

  /* Pitanja: samo jedno otvoreno (rezerva za pregledace bez <details name>) */
  function jednoOtvoreno() {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('details[data-lp-jedno]') || !d.open) return;
      document.querySelectorAll('details[data-lp-jedno][name="' + d.getAttribute('name') + '"]').forEach(function (x) { if (x !== d && x.open) x.open = false; });
    }, true);
  }

  function init() {
    jednoOtvoreno();
    paralaks();
    document.querySelectorAll('[data-lp-seq]').forEach(sekvenca);
    document.querySelectorAll('[data-lp-karusel]').forEach(karusel);
    videi();
    document.querySelectorAll('[data-lp-galerija]').forEach(galerija);
    document.querySelectorAll('dialog[data-lp-modal]').forEach(paket);
    document.querySelectorAll('[data-lp-lepljiva]').forEach(lepljiva);
    document.querySelectorAll('[data-lp-ponude]').forEach(ponude);
    document.querySelectorAll('[data-lp-biraj]').forEach(biraj);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
